import React, { useState, useEffect } from "react";
import "./OngoingProjects.css";

const OngoingProjects = () => {
  const projects = [
    {
      title: "FB Wynwood",
      description: "HVAC Project in Miami Wynwood Area.",
      images: [
        "/Images/Ongoing Projects/Wynwood/5.png",
        "/Images/Ongoing Projects/Wynwood/0.jpg",
        "/Images/Ongoing Projects/Wynwood/4.png",
        "/Images/Ongoing Projects/Wynwood/3.png",
        "/Images/Ongoing Projects/Wynwood/2.png",
        "/Images/Ongoing Projects/Wynwood/1.png",
      ],
    },

    {
      title: "Culmer Apartments",
      description: "Plumbing Project in Miami.",
      images: [
        "/Images/Ongoing Projects/Culmer/Image (23).jpg",
        "/Images/Ongoing Projects/Culmer/Image (24).jpg",
        "/Images/Ongoing Projects/Culmer/Culmer 4.jpg",
        "/Images/Ongoing Projects/Culmer/Image (25).jpg",
    
      ],
    },

    {
      title: "Tyson",
      description: "Plumbing Project in Tampa.",
      images: [
        "/Images/Ongoing Projects/Tyson/Image (15).jpg",
        "/Images/Ongoing Projects/Tyson/Image (13).jpg",
        "/Images/Ongoing Projects/Tyson/Image (14).jpg",
        
      ],
    },
      {
      title: "Caretta",
      description: "Pulmbing Project in Juno Beach",
      images: [
        "/Images/Ongoing Projects/Caretta/Image (18).jpg",
        "/Images/Ongoing Projects/Caretta/Image (19).jpg",
        "/Images/Ongoing Projects/Caretta/Image (67).jpg",
        "/Images/Ongoing Projects/Caretta/Image (17).jpg",
        
        
      ],
    },

      {
      title: "Coral Gables",
      description: "Plumbing Project in Miami",
      images: [
        "/Images/Ongoing Projects/Coral Gables/Image (21).jpg",
        "/Images/Ongoing Projects/Coral Gables/Image (20).jpg",
        "/Images/Ongoing Projects/Coral Gables/Image (22).jpg",
    
      ],
    },


   
    {
      title: "Perrine Village",
      description: "Plumbing Project in Miami.",
      images: [
       
        "/Images/Ongoing Projects/Perrine Village/Image (8).jpg",
        "/Images/Ongoing Projects/Perrine Village/Image (10).jpg",
        "/Images/Ongoing Projects/Perrine Village/Image (9).jpg",
        "/Images/Ongoing Projects/Perrine Village/Image (11).jpg",
      ],
    },

    
  ];

  // Store current image index for each project
  const [currentIndexes, setCurrentIndexes] = useState(
    projects.map(() => 0)
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndexes((prevIndexes) =>
        prevIndexes.map((index, projectIdx) =>
          (index + 1) % projects[projectIdx].images.length
        )
      );
    }, 2000);

    return () => clearInterval(interval);
  }, [projects]);

  return (
    <div className="ongoing-projects">
      <h2 className="section-title">Ongoing Projects</h2>
      {projects.map((project, idx) => (
        <div key={idx} className="project-card">
          <div className="project-text">
            <h3>{project.title}</h3>
            <p>{project.description}</p>
          </div>
          <div className="project-image">
            <img
              src={project.images[currentIndexes[idx]]}
              alt={project.title}
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default OngoingProjects;
